import { TextVariant } from './types';

export const WARING_MODAL_CONSTANTS: Record<string, TextVariant> = {
  title: { common: '유의사항' },
  satelliteTitle: { common: '새틀라이트 유의 사항' },
  mainEventTitle: { common: '오프라인 이벤트 유의 사항' },
  confirmBtn: { common: '확인' },
};

export const SATELLITE_ITEMS = [
  '새틀라이트는 반드시 본인명의 계정으로 참가를 진행해야 합니다.',
  '각 새틀라이트는 시작 5분 전부터 입장 가능합니다.',
  '새틀라이트는 입장 마감 전이라면 리엔트리를 할 수 있습니다.',
  '중도 포기 시 참가비는 환불되지 않습니다.',
  '인더머니를 달성하여 획득한 티켓은 티켓함으로 지급 됩니다.',
  '참가권을 획득한 경우에도 추가로 획득할 수 있습니다.',
  '본 새틀라이트는 내부 사정에 따라 통보 없이 종료될 수 있으며 부적절한 방법으로 참여 시 운영자에 의해 제재될 수 있습니다.',
] as const;

export const MAIN_EVENT_ITEMS = [
  '본 참가권은 NLH Main Event Day 1에 한정됩니다.',
  '본 이벤트에서 선발되실 경우, NLH Main Event Day 1 참가권이 주어집니다.',
  'NLH Main Event Day 1참가는 본인확인을 거친 경우에만 참여할 수 있으며, 참가권은 타인에게 양도, 판매될 수 없습니다.',
  'NLH Main Event Day 1은 JOPT가 주관하는 행사로 참여자는 JOPT의 운영방식에 따라야 합니다.',
] as const;
